// roles

import http from '../../../store/api/http' 

const actions = {
    getRoles(context, param) {
    	console.log('action->getRoles')
    	let query = '?page=' + param.page
    	query += '&sortby=' + (param.sortBy ? param.sortBy : '')
    	query += '&sortdir=' + (param.sortDesc ? param.sortDesc : 'asc')
    	query += '&filter=' + param.filter
    	query += '&paginate=yes'
		return new Promise((resolve, reject) => {
			http.get('/api/roles' + query)
			.then(function (response) {
		    	if(typeof(response.data) === 'object' && response.data.data instanceof Array) {
		    		context.commit('getRoles', response.data.data)
		    	} else reject(error)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    editRole(context, data) {
    	console.log('action->editRole')
		return new Promise((resolve, reject) => {
			http.get('/api/roles/' + data + '/edit')
			.then(function (response) {
		    	context.commit('getRole', response.data)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    createRole(context, data) {
    	console.log('action->createRole')
		return new Promise((resolve, reject) => {
			http.post('/api/roles', data)
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    updateRole(context, data) {
    	console.log('action->updateRole')
		return new Promise((resolve, reject) => {
			http.patch('/api/roles/' + data.id, data)
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    storeRole(context, data) {
    	console.log('action->storeRole')
		return new Promise((resolve, reject) => {
			context.dispatch(data.id>0 ? 'updateRole' : 'createRole', data)
      		.then((response) => {
				resolve(response)
  			})
	    	.catch((error) => {
				reject(error)
		    });
		})
    },

};

export default actions;